import React, { useEffect, useState, useMemo } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  BtnIcon,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  CustomTabView,
  ImportXmlFiles,
  InputCnpj,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'

import { showMessageBox, showLoadingBox, hideLoadingBox } from '../../../../store/actions/system.actions'
import * as EmpresaHttp from '../../../../services/api/https/settings/company.http'
import * as RegrasFreteHttp from '../../../../services/api/https/registration/regras-frete.http'

import * as EmpresaRegistrationHttp from '../../../../services/api/https/registration/company.http'
import * as CompanyCnpjHttp from '../../../../services/api/https/registration/company-cnpj.http'
import { errorHandler } from '../../../../services/util/error.service'
import {
  getCnpjDataFocusNfe,
  handleAssocTiposArquivoComEmpresa,
} from '../../../../services/api/https/system/system.http'
import { tableCellCentered } from '../../../../assets/js/styles'

import { usersCompanysAssociatonHandler } from '../../../../services/api/https/settings/user.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { TabPanel } from 'primereact/tabview'
import { FaRegTrashAlt } from 'react-icons/fa'
import * as SifHttp from '../../../../services/api/https/registration/sif-unit.http'
import { menuItemsAllowed } from '../../../../services/permission/menus'

function Empresa({ dispatch, history, selectedTp }) {
  // Vars
  const initEmpresa = {
    id: null,
    name: '',
    cnpj: '',
    actived: true,
    qte_caixas_por_pallet: '',
    sigla: '',
    company_code: '',
    frete_min: 0,
    enviar_email_cte: false,
    email_destinatario_cte: '',
    business_unit: '',
  }

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresa, setSelectedEmpresa] = useState(initEmpresa)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (!selectedTp) dispatch(showMessageBox(null, 'Selecione um Operador Logístico'))
    else getEmpresas()
  }, [selectedTp])

  // Events
  const onBtnNovo = () => {
    setSelectedEmpresa(initEmpresa)
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSave = async empresa => {
    // Normaliza o campo actived para garantir exibição correta na tabela
    const index = empresas.findIndex(l => l.id === empresa.id)
    if (index !== -1) {
      const nEmpresas = [...empresas]
      const prevActived = nEmpresas[index].actived
      nEmpresas[index] = {
        ...empresa,
        actived:
          empresa.actived !== undefined && empresa.actived !== null
            ? !!empresa.actived
            : !!prevActived,
      }
      setEmpresas(nEmpresas)
    } else {
      setEmpresas([
        {
          ...empresa,
          actived:
            empresa.actived !== undefined && empresa.actived !== null ? !!empresa.actived : true,
        },
        ...empresas,
      ])
    }
    dispatch(showMessageBox('Empresa salva com sucesso', null))
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onRowClicked = empresa => {
    setSelectedEmpresa({
      ...empresa,
      enviar_email_cte: !!empresa.enviar_email_cte,
      email_destinatario_cte: empresa.email_destinatario_cte || '',
      business_unit: empresa.business_unit || '',
    })
    setShowModal(true)
  }

  const onXmlImportationSuccess = async data => {
    try {
      setIsLoading(true)
      await EmpresaRegistrationHttp.postImportCompanyXml({
        user_id: getUsuarioInfo().id,
        tp_id: selectedTp,
        data,
      })
      await getEmpresas()
      dispatch(showMessageBox('Importação de Empresas/Produtos realizada com sucesso', null))
    } catch (error) {
      const { message } = error
      if (message) {
        dispatch(showMessageBox(null, message))
      } else {
        dispatch(showMessageBox(null, error))
      }
    } finally {
      setIsLoading(false)
    }
  }

  const onError = error => {
    dispatch(showMessageBox(null, error))
  }

  // Helpers
  const getEmpresas = async () => {
    try {
      setIsLoading(true)
      const fetchedEmpresas = await EmpresaHttp.getCompaniesUser()

      setEmpresas(fetchedEmpresas)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>2.13 - Gestão de Empresas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <div className="p-grid">
              <div className="p-col-12">
                <ImportXmlFiles
                  label={
                    <span style={{ paddingLeft: 10, paddingRight: 10 }}>
                      Importar Empresas/Produtos XML
                    </span>
                  }
                  onSuccess={onXmlImportationSuccess}
                  onError={onError}
                />
              </div>
              <div className="p-col-12">
                <EmpresaDataTable empresas={empresas} onRowClick={onRowClicked} />
              </div>
            </div>
          )}
        </CustomPanel>
      </div>
      <EmpresaModal
        isVisible={showModal}
        onError={onModalError}
        onSuccess={onModalSave}
        onClose={onModalClose}
        empresa={selectedEmpresa}
        selectedTp={selectedTp}
        dispatch={dispatch}
      />
    </div>
  )
}

function EmpresaModal({ empresa, isVisible, onClose, onSuccess, onError, selectedTp, dispatch }) {
  const [selectedEmpresa, setSelectedEmpresa] = useState(empresa)

  const [state, setState] = useState({
    activeTab: 0,
    globalFilter: '',
    regrasFrete: [],
    lastId: 0,
    faixasKm: [],
    regrasFaturamento: [],
    sifUnits: [],
    showSifModal: false,
    editingSif: null,
    cnpjs: [],
    newCnpj: '',
  })

  const fetchInicial = async empresa => {
    try {
      const [faixasKm, regrasFaturamento, regrasFrete] = await Promise.all([
        RegrasFreteHttp.getFaixaKm(selectedTp),
        RegrasFreteHttp.getRegrasFaturamento(selectedTp),
        empresa.id && RegrasFreteHttp.getRegraFrete(selectedTp, empresa.id),
      ])
      console.log(regrasFaturamento)

      setState(prevState => ({
        ...prevState,
        activeTab: 0,
        faixasKm,
        regrasFaturamento,
        regrasFrete: regrasFrete
          ? regrasFrete.map(r => ({
              id: r.id,
              faixaKm: faixasKm.find(f => f.id === r.faixa_km_id),
              regraFaturamento: regrasFaturamento.find(f => f.id === r.regra_faturamento_id),
              value: r.value,
            }))
          : [],
      }))
      if (empresa.id) {
        const [sifUnits, cnpjs] = await Promise.all([
          SifHttp.getSifUnits(empresa.id).catch(() => []),
          CompanyCnpjHttp.getCompanyCnpjs(empresa.id).catch(() => []),
        ])
        setState(prev => ({ ...prev, sifUnits, cnpjs }))
      } else {
        setState(prev => ({ ...prev, sifUnits: [], cnpjs: [] }))
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (isVisible && selectedTp) {
      setSelectedEmpresa(empresa)
      fetchInicial(empresa)
    }
    if (!isVisible) {
      setSelectedEmpresa({})
      setState({
        activeTab: 0,
        globalFilter: '',
        regrasFrete: [],
        lastId: 0,
        faixasKm: [],
        regrasFaturamento: [],
        sifUnits: [],
        showSifModal: false,
        editingSif: null,
        cnpjs: [],
        newCnpj: '',
      })
    }
  }, [selectedTp, empresa, isVisible])

  function verifyMenuItemAllowed(menuItem) {
    return menuItemsAllowed([menuItem]).length > 0
  }

  const onNovaRegraFrete = () => {
    setState(prevState => ({
      ...prevState,
      lastId: prevState.lastId + 1,
      regrasFrete: [
        ...prevState.regrasFrete,
        {
          id: prevState.lastId + 1,
          faixaKm: null,
          regraFaturamento: null,
          value: null,
        },
      ],
    }))
  }

  const handleRemoveFrete = frete => {
    setState(prevState => {
      prevState.regrasFrete = prevState.regrasFrete.filter(r => r.id !== frete.id)
      return { ...prevState }
    })
  }

  const fetchCnpjData = async cnpj => {
    getCnpjDataFocusNfe(cnpj)
      .then(async res => {
        setSelectedEmpresa(prevState => ({
          ...prevState,
          name: res.razao_social,
        }))
      })
      .catch(err => onError(err))
  }

  const onCnpjChange = cnpj => {
    setSelectedEmpresa({
      ...selectedEmpresa,
      cnpj,
    })
    if (cnpj.length === 14 && !empresa.id) fetchCnpjData(cnpj)
  }

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const {
        id,
        name,
        actived,
        cnpj,
        qte_caixas_por_pallet,
        sigla,
        company_code,
        frete_min,
        enviar_email_cte,
        email_destinatario_cte,
        business_unit,
      } = selectedEmpresa
      if (name.trim().length < 3) throw new Error('Nome da Empresa Incorreto')
      if (cnpj === '') throw new Error('CNPJ Incorreto')
      if (qte_caixas_por_pallet === '') throw new Error('Quantidade de Caixas Invalida')
      if (sigla === '') throw new Error('Sigla Invalida')
      if (company_code === '') throw new Error('Código da Empresa Inválido')
      if (enviar_email_cte) {
        const destinatario = (email_destinatario_cte || '').trim()
        if (destinatario === '')
          throw new Error(
            'Destinatário é obrigatório quando o envio de email ao emitir CTE está ativo',
          )
        if (!/^\S+@\S+\.\S+$/.test(destinatario))
          throw new Error('Destinatário do email de CTe inválido')
      }

      state.regrasFrete.forEach(r => {
        if (!r.faixaKm) throw new Error('Selecione uma Faixa de Km')
        if (!r.regraFaturamento) throw new Error('Selecione uma Regra de Faturamento')
        if (!r.value) throw new Error('Informe um Valor')
      })

      const { company } = await EmpresaHttp.saveCompany({
        id,
        name,
        actived,
        cnpj,
        qte_caixas_por_pallet,
        sigla,
        company_code,
        frete_min,
        enviar_email_cte,
        email_destinatario_cte,
        business_unit,
      })
      if (!id) {
        await Promise.all([
          handleAssocTiposArquivoComEmpresa(company.id, 3, 'selected', false),
          handleAssocTiposArquivoComEmpresa(company.id, 18, 'selected', true),
          handleAssocTiposArquivoComEmpresa(company.id, 53, 'selected', true),
          usersCompanysAssociatonHandler({
            user_id: getUsuarioInfo().id,
            company_id: company.id,
            actived: true,
          }),
        ])
        if (state.regrasFrete.length > 0) {
          await RegrasFreteHttp.saveRegraFrete(
            state.regrasFrete.map(r => ({
              value: r.value,
              faixa_km_id: r.faixaKm.id,
              regra_faturamento_id: r.regraFaturamento.id,
              tp_id: selectedTp,
              company_id: company.id,
            })),
          )
        }
      } else {
        await RegrasFreteHttp.updateRegraFrete(
          selectedTp,
          id,
          state.regrasFrete.map(r => ({
            value: r.value,
            faixa_km_id: r.faixaKm.id,
            regra_faturamento_id: r.regraFaturamento.id,
            tp_id: selectedTp,
            company_id: id,
          })),
        )
      }
      onSuccess(company)
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  const onInputChange = (regraFrete, value, field) => {
    setState(prevState => {
      const index = prevState.regrasFrete.findIndex(r => r.id === regraFrete.id)
      if (index !== -1) {
        prevState.regrasFrete[index][field] = value
      }
      return { ...prevState }
    })
  }

  const onNovoSif = () => {
    if (!selectedEmpresa.id) {
      return onError('Salve a Empresa antes de cadastrar SIF')
    }
    setState(prev => ({
      ...prev,
      showSifModal: true,
      editingSif: {
        company_id: selectedEmpresa.id,
        sif_code: '',
        unit_name: '',
        inspection_service: 'SIF',
        unit_type: null,
        notes: '',
        actived: true,
      },
    }))
  }

  const onEditSif = row => {
    setState(prev => ({
      ...prev,
      showSifModal: true,
      editingSif: { ...row },
    }))
  }

  const onSifSaved = saved => {
    // atualiza a linha (update) ou insere (create)
    const idx = state.sifUnits.findIndex(u => u.id === saved.id)
    const list = idx !== -1 ? [...state.sifUnits] : [...state.sifUnits, saved]
    if (idx !== -1) list[idx] = saved
    setState(prev => ({ ...prev, sifUnits: list, showSifModal: false, editingSif: null }))
  }

  const onSifClose = () => {
    setState(prev => ({ ...prev, showSifModal: false, editingSif: null }))
  }

  const onAddCnpj = async () => {
    if (!selectedEmpresa.id) return onError('Salve a Empresa antes de cadastrar CNPJs secundários')
    if (!state.newCnpj || state.newCnpj.length !== 14) return onError('CNPJ inválido')
    dispatch(showLoadingBox('Aguarde...'))
    try {
      const saved = await CompanyCnpjHttp.saveCompanyCnpj(selectedEmpresa.id, state.newCnpj)
      setState(prev => ({ ...prev, cnpjs: [...prev.cnpjs, saved], newCnpj: '' }))
    } catch (err) {
      onError(err)
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onDeleteCnpj = async cnpj => {
    dispatch(showLoadingBox('Aguarde...'))
    try {
      await CompanyCnpjHttp.deleteCompanyCnpj(selectedEmpresa.id, cnpj.id)
      setState(prev => ({ ...prev, cnpjs: prev.cnpjs.filter(c => c.id !== cnpj.id) }))
    } catch (err) {
      onError(err)
    } finally {
      dispatch(hideLoadingBox())
    }
  }
  return (
    <CustomModal
      width={800}
      header="Empresa"
      isVisible={isVisible}
      onClose={() => {
        onClose()
      }}
    >
      <form>
        <CustomTabView
          activeIndex={state.activeTab}
          onTabChange={tab => setState(prevState => ({ ...prevState, activeTab: tab }))}
        >
          <TabPanel header={'Dados'}>
            <div className="p-grid">
              <div className="p-md-6 p-col-12">
                <InputText
                  label="Descrição :"
                  marginTop={10}
                  value={selectedEmpresa.name}
                  onChange={value => setSelectedEmpresa({ ...selectedEmpresa, name: value })}
                />
              </div>
              <div className="p-md-6 p-col-12">
                <InputCnpj
                  label="CNPJ :"
                  marginTop={10}
                  value={selectedEmpresa.cnpj}
                  onChange={({ value }) => onCnpjChange(value)}
                />
              </div>

              <div className="p-col-6">
                <InputText
                  label="Sigla :"
                  marginTop={10}
                  value={selectedEmpresa.sigla || ''}
                  onChange={value => setSelectedEmpresa({ ...selectedEmpresa, sigla: value })}
                />
                <small style={{ color: 'red' }}>
                  Sigla utilizada durante processo de cadastramento automático dos clientes. Esse
                  valor deve ser ÚNICO
                </small>
              </div>
              <div className="p-col-6">
                <InputText
                  label="Company Code - Xml Consolidado :"
                  marginTop={10}
                  value={selectedEmpresa.company_code || ''}
                  onChange={value =>
                    setSelectedEmpresa({ ...selectedEmpresa, company_code: value })
                  }
                />
                <small style={{ color: 'red' }}>
                  Toda empresa deve ser cadastrada como CLIENTE e associar um COMPANY_CODE associado
                  a ela mesma. Esta informação será utilizada durante o processo de importação do
                  XML Consolidado
                </small>
              </div>
              <div className="p-col-6">
                <InputNumeroInteiro
                  label="Qte de Caixas Por Pallet:"
                  value={selectedEmpresa.qte_caixas_por_pallet}
                  onChange={value =>
                    setSelectedEmpresa({ ...selectedEmpresa, qte_caixas_por_pallet: value })
                  }
                />
              </div>
              <div className="p-col-6">
                <InputText
                  label="Business Unit :"
                  marginTop={10}
                  value={selectedEmpresa.business_unit || ''}
                  onChange={value =>
                    setSelectedEmpresa({ ...selectedEmpresa, business_unit: value })
                  }
                />
                <small style={{ color: 'red' }}>
                  Utilizada na importação "Danone - Roteiro" para converter a coluna BU / Cliente
                  Colog do arquivo na empresa correspondente
                </small>
              </div>
              <div className="p-col-12">
                <div className="p-grid">
                  <div className="p-col-6">
                    <CustomCheckbox
                      onChange={value =>
                        setSelectedEmpresa({
                          ...selectedEmpresa,
                          enviar_email_cte: value,
                          email_destinatario_cte: value
                            ? selectedEmpresa.email_destinatario_cte
                            : '',
                        })
                      }
                      checked={!!selectedEmpresa.enviar_email_cte}
                    >
                      Enviar email ao emitir CTE?
                    </CustomCheckbox>
                  </div>
                  {!!selectedEmpresa.enviar_email_cte && (
                    <div className="p-col-6">
                      <InputText
                        label="Destinatário :*"
                        value={selectedEmpresa.email_destinatario_cte || ''}
                        onChange={value =>
                          setSelectedEmpresa({ ...selectedEmpresa, email_destinatario_cte: value })
                        }
                      />
                      <small style={{ color: 'red' }}>
                        Endereço de email que receberá o XML de cada CT-e emitido/cancelado desta
                        empresa
                      </small>
                    </div>
                  )}
                </div>
              </div>
              <div className="p-col-12">
                <CustomCheckbox
                  onChange={value => setSelectedEmpresa({ ...selectedEmpresa, actived: value })}
                  checked={selectedEmpresa.actived}
                >
                  Ativo
                </CustomCheckbox>
              </div>
              <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end' }}>
                <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
              </div>
            </div>
          </TabPanel>
          <TabPanel header={'Regras de Frete'}>
            <div className="p-grid">
              <div className="p-col-6">
                <InputNumeroDecimal
                  label="Frete Mínimo:*"
                  marginTop={10}
                  value={selectedEmpresa.frete_min}
                  onChange={value => setSelectedEmpresa({ ...selectedEmpresa, frete_min: value })}
                />
              </div>
              <div className="p-col-12">
                <DataTable
                  value={state.regrasFrete}
                  header={
                    <div className="p-grid" style={{ marginTop: 5 }}>
                      <Btn className="p-button-success" onClick={onNovaRegraFrete}>
                        Novo
                      </Btn>
                    </div>
                  }
                  paginator={true}
                  rows={10}
                >
                  <Column
                    field="faixaKm"
                    header="Faixa de Km"
                    body={item => (
                      <CustomDropdown
                        optionLabel="name"
                        marginTop={0}
                        options={state.faixasKm}
                        value={item.faixaKm}
                        filter={true}
                        onChange={value => onInputChange(item, value, 'faixaKm')}
                      />
                    )}
                  />
                  <Column
                    field="regraFaturamento"
                    header="Regra de Faturamento"
                    body={item => {
                      return (
                        <CustomDropdown
                          marginTop={0}
                          optionLabel="name"
                          options={state.regrasFaturamento}
                          value={item.regraFaturamento}
                          filter={true}
                          onChange={value => onInputChange(item, value, 'regraFaturamento')}
                          itemTemplate={({ name, type }) => `${name} (${type})`}
                        />
                      )
                    }}
                  />
                  <Column
                    field="value"
                    header="Valor"
                    style={tableCellCentered(150)}
                    body={item => (
                      <div>
                        <span>{(item.regraFaturamento && item.regraFaturamento.type) || ''}</span>
                        <InputNumeroDecimal
                          marginTop={0}
                          decimalScale={
                            item.regraFaturamento && item.regraFaturamento.type === '%Faturamento' ? 3 : 2
                          }
                          value={item.value}
                          onChange={value => onInputChange(item, value, 'value')}
                        />
                      </div>
                    )}
                  />
                  <Column
                    header=""
                    style={tableCellCentered(80)}
                    body={frete => (
                      <BtnIcon onClick={() => handleRemoveFrete(frete)}>
                        <FaRegTrashAlt color="red" size={18} />
                      </BtnIcon>
                    )}
                  />
                </DataTable>
              </div>
              <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end' }}>
                <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
              </div>
            </div>
          </TabPanel>
          {verifyMenuItemAllowed({ id: 47, content: '2.13 - Gestão de Empresas - TAB SIF' }) && (
            <TabPanel header={'Serviço de Inspeção'}>
              <div className="p-grid">
                <div className="p-col-12">
                  <DataTable
                    value={state.sifUnits}
                    paginator={true}
                    selectionMode="single"
                    rows={10}
                    onRowClick={e => onEditSif(e.data)}
                    header={
                      <div className="p-grid" style={{ marginTop: 5 }}>
                        <Btn className="p-button-success" onClick={onNovoSif}>
                          Novo
                        </Btn>
                      </div>
                    }
                  >
                    <Column field="sif_code" header="Código" style={{ width: 120 }} />
                    <Column field="unit_name" header="Unidade" />
                    <Column field="inspection_service" header="Serviço" style={{ width: 120 }} />
                    <Column field="unit_type" header="Tipo Unidade" style={{ width: 180 }} />
                    <Column
                      field="actived"
                      header="Ativo"
                      style={{ textAlign: 'center', width: 100 }}
                      body={row => <CustomCheckbox disabled checked={!!row.actived} />}
                    />
                  </DataTable>
                </div>
              </div>
              <SifUnitModal
                show={state.showSifModal}
                data={state.editingSif}
                onClose={onSifClose}
                onSaved={onSifSaved}
                onError={onError}
              />
            </TabPanel>
          )}
          <TabPanel header={'CNPJs Secundários'}>
            <div className="p-grid">
              <div className="p-md-8 p-col-12">
                <InputCnpj
                  label="CNPJ:"
                  marginTop={10}
                  value={state.newCnpj}
                  onChange={({ value }) => setState(prev => ({ ...prev, newCnpj: value }))}
                />
              </div>
              <div className="p-md-4 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
                <Btn style={{ marginBottom: 0 }} onClick={e => { e.preventDefault(); onAddCnpj() }}>
                  Adicionar
                </Btn>
              </div>
              <div className="p-col-12">
                <DataTable
                  value={state.cnpjs}
                  paginator={true}
                  rows={5}
                >
                  <Column
                    field="cnpj"
                    header="CNPJ"
                    body={row => <Cnpj>{row.cnpj}</Cnpj>}
                  />
                  <Column
                    header=""
                    style={tableCellCentered(80)}
                    body={row => (
                      <BtnIcon onClick={e => { e.preventDefault(); onDeleteCnpj(row) }}>
                        <FaRegTrashAlt color="red" size={18} />
                      </BtnIcon>
                    )}
                  />
                </DataTable>
              </div>
            </div>
          </TabPanel>
        </CustomTabView>
      </form>
    </CustomModal>
  )
}

function EmpresaDataTable({ empresas, onRowClick }) {
  const [globalFilter, setGlobalFilter] = useState('')
  return (
    <DataTable
      value={empresas}
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator
      rows={10}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="name" header="Empresa" />
      <Column
        field="cnpj"
        header="CNPJ"
        style={{ textAlign: 'center', width: 200 }}
        body={rowData => <Cnpj>{rowData.cnpj}</Cnpj>}
      />
      <Column
        field="actived"
        header="Ativo"
        style={{ textAlign: 'center', width: 100 }}
        body={rowData => <CustomCheckbox disabled checked={!!rowData.actived} />}
      />
    </DataTable>
  )
}

function SifUnitModal({ show, data, onClose, onSaved, onError }) {
  const [sif, setSif] = useState(
    data || {
      company_id: null,
      sif_code: '',
      unit_name: '',
      inspection_service: 'SIF',
      unit_type: null,
      notes: '',
      actived: true,
    },
  )

  useEffect(() => {
    setSif(data || {})
  }, [data])

  const inspectionServices = useMemo(() => [{ name: 'SIF' }, { name: 'SIE' }, { name: 'SIM' }], [])

  const unitTypes = useMemo(
    () => [
      { name: 'ABATE' },
      { name: 'DESOSSA' },
      { name: 'INDUSTRIALIZACAO' },
      { name: 'ARMAZENAGEM' },
      { name: 'LATICINIOS' },
      { name: 'EMBUTIDOS' },
      { name: 'OUTROS' },
    ],
    [],
  )

  const onSave = async () => {
    try {
      if (!sif.company_id) throw new Error('Empresa inválida')
      if (!sif.sif_code || String(sif.sif_code).trim() === '') throw new Error('Informe o SIF')
      if (String(sif.sif_code).length > 12)
        throw new Error('O SIF deve ter no máximo 12 caracteres')
      if (!sif.unit_name || String(sif.unit_name).trim() === '')
        throw new Error('Informe o nome da Unidade')
      if (!sif.inspection_service) throw new Error('Informe o Serviço de Inspeção')
      if (!sif.unit_type) throw new Error('Informe o Tipo da Unidade')

      const saved = await SifHttp.saveSifUnit({
        id: sif.id,
        company_id: sif.company_id,
        sif_code: String(sif.sif_code).toUpperCase(),
        unit_name: String(sif.unit_name).toUpperCase(),
        inspection_service: sif.inspection_service,
        unit_type: sif.unit_type,
        notes: sif.notes || null,
        actived: !!sif.actived,
      })

      onSaved(saved)
    } catch (error) {
      onError(error)
    }
  }

  return (
    <CustomModal header="Serviço de Inspeção" isVisible={show} onClose={onClose} width={600}>
      <div className="p-grid">
        <div className="p-col-4">
          <InputText
            label="Código:*"
            marginTop={10}
            value={sif.sif_code || ''}
            onChange={v => setSif(prev => ({ ...prev, sif_code: v }))}
            maxLength={12}
          />
        </div>
        <div className="p-col-8">
          <InputText
            label="Unidade:*"
            marginTop={10}
            value={sif.unit_name || ''}
            onChange={v => setSif(prev => ({ ...prev, unit_name: v }))}
          />
        </div>

        <div className="p-col-6">
          <CustomDropdown
            label="Serviço de Inspeção:*"
            optionLabel="name"
            options={inspectionServices}
            value={inspectionServices.find(o => o.name === sif.inspection_service) || null}
            onChange={opt =>
              setSif(prev => ({ ...prev, inspection_service: opt ? opt.name : null }))
            }
            placeholder="Selecione"
          />
        </div>

        <div className="p-col-6">
          <CustomDropdown
            label="Tipo de Unidade:*"
            optionLabel="name"
            options={unitTypes}
            value={unitTypes.find(o => o.name === sif.unit_type) || null}
            onChange={opt => setSif(prev => ({ ...prev, unit_type: opt ? opt.name : null }))}
            placeholder="Selecione"
          />
        </div>

        <div className="p-col-12">
          <InputText
            label="Observações:"
            value={sif.notes || ''}
            onChange={v => setSif(prev => ({ ...prev, notes: v }))}
          />
        </div>

        <div className="p-col-12">
          <CustomCheckbox
            onChange={v => setSif(prev => ({ ...prev, actived: v }))}
            checked={!!sif.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>

        <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end', gap: 10 }}>
          <Btn className="p-button-secondary" onClick={onClose}>
            Cancelar
          </Btn>
          <Btn onClick={onSave}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Empresa))
